import httpClient from './http'

/**
 * 设置全局请求的基础URL
 * @param {string} baseUrl - 如 "http://192.168.1.100:8080"
 */
export function setBaseUrl(baseUrl) {
  httpClient.defaults.baseURL = baseUrl
}
export function setToken(token) {
  httpClient.defaults.headers.common['Authorization'] = token
}
